export enum ProjectOAuth2MicrosoftPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
